import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { 
  faExclamationTriangle, IconDefinition
} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-fd-alert',
    templateUrl: './fd-alert.component.html',
    styleUrls: ['./fd-alert.component.scss'],
    standalone: false
})
export class FdAlertComponent implements OnInit {
  @Output() buttonClicked = new EventEmitter<any>();
  icons: { [key: string]: IconDefinition }

  constructor(public dialogRef: MatDialogRef<FdAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogData) { 

      this.icons = { faExclamationTriangle };
    }

  ngOnInit() {
  }

  handleClick(): void {
    if (this.data.callbackFn) {
      this.data.callbackFn();
    }
    this.dialogRef.close();
  }
}

export interface AlertDialogData {
  title: string;
  description: string;
  callbackFn: () => any;
}

export enum ModalDefinitions {
  DEFAULT_MODAL_WIDTH = '450px'
}
